export const popups = {
  registerRequest: {
    title: 'Registration Request',
    description: 'Fill out the form and we will contact you.',
    button: 'Submit Registration Request',
    form: {
      noteLabel: 'How did you hear about us?',
      notePlaceholder: 'How did you hear about us?',
      checkboxExperience: 'I have club experience',
      club: {
        nameLabel: 'Club Name',
        namePlaceholder: 'Club Name'
      }
    }
  },
  invite: {
    title: 'Are you 18 years old?',
    description: 'Confirm your age to use the platform',
    confirm: 'Yes, I am 18'
  },
  deleteAccount: {
    title: 'Are you sure you want to delete your account?',
    subTitle: 'Deletion cannot be undone.',
    description:
      'Instead of deleting, you can hide your profile. It will not be available to anyone except you until you decide to reopen it.'
  },
  exitFromProfile: {
    title: 'Are you sure you want to log out?',
    description: 'Confirm logout from your account'
  },
  hideAccount: {
    title: 'Are you sure you want to hide your account?',
    description:
      'Your profile will not be viewable by anyone except you until you decide to reopen it. This will hide your account from clubs and other artists.'
  },
  mainPhoto: {
    title: 'Main Photo',
    description: 'Specify a cover photo for your resume'
  },
  updateVideo: {
    title: 'Video Upload',
    description: 'Please wait for the video to upload'
  },
  consumation: {
    title: 'Consumption',
    description:
      'Enter the 5 most popular consumption items, their prices, and the percentage of the price for the artist’s payout.'
  },
  crazyMenu: {
    title: 'Crazy Menu',
    description: 'Enter the 5 most popular crazy menu items and their prices.'
  },
  warningOnCloseOnboarding: {
    title: 'Your advertisement will not be published',
    description: 'Are you sure you want to cancel filling out the details?'
  },
  foreignLanguage: {
    title: 'Level'
  },
  createWorkItem: {
    title: 'Invitation Confirmation',
    inviteDescription:
      'This information is provisional. You can discuss it in the chat with the artist and update the invitation.',
    requestDescription:
      'This information is provisional. You can discuss it in the chat with the club and update the request.',
    suggestVacancy: 'Suggest a vacancy for the artist',
    selectVacancy: 'Specify the vacancy of interest',
    ticketCreditOption: 'Ticket credit option',
    ticketCreditRequired: 'Is ticket credit required?'
  },
  clubWorkInteraction: {
    artistWorkAtClub: 'The artist is working at your club.',
    setLastDay: {
      title: 'Do you want to set the artist’s last working day?',
      setLastWorkDate: 'Specify the artist’s last working day',
      description:
        'Once you set the last date for the artist, it cannot be changed. After the set date, the artist will end the contract with your club.'
    },
    artistArrival: {
      title: 'Confirm the artist’s arrival?',
      description: 'You confirm the artist’s presence at your club',
      information:
        'Work will begin once you confirm the artist’s presence at the workplace.'
    },
    workCancel: {
      title: 'Confirm contract cancellation?',
      description: 'You confirm the cancellation of the contract'
    },
    wantEndDate: {
      title: 'The artist wants to set a last working day.'
    },
    newEndDate: {
      title: 'Last Working Day'
    }
  },
  artistWorkInteraction: {
    manageCurentContract: {
      pendingLastWorkDateRequest:
        'Your request to end the contract is under review.',
      workStartOnArtistArrivalConfirm:
        'Work will begin once the club confirms your presence at the workplace.',
      weCanRequestLastWorkDate:
        'You can submit a request to end the contract, and the club will send you the date of your last working day.',
      clubSetLastWorkDate:
        'The club has set your last working day at this club.'
    }
  },
  changeProfile: {
    title: 'My Clubs'
  },
  confirmOnboardingCompletion: {
    title: 'Your portfolio has been published',
    description: 'Now clubs can invite you for work'
  },
  videoUploading: {
    title: 'Video Upload',
    description: 'Please wait for the video to upload'
  },
  addWorkItem: {
    title: 'Place of Work',
    vacancyQuestion: 'Which vacancy did you work in?',
    validationMessage:
      'You have already indicated that you are currently working.'
  },
  selectMainPhoto: {
    title: 'Main Photo',
    description: 'Specify a cover photo for your resume'
  }
};
